// ポータル画面から起動の機能を閉じる処理
export const funcClose = () => {
	if (localStorage.getItem('portalFlg') === '0') {
		if (window.opener && window.opener.closed === false) {
			// 呼び出し元ウィンドウが生きている場合はそちらで処理してもらう
			window.opener.postMessage('endView', '*');
		}
		localStorage.removeItem('portalFlg');
		window.close();
	}
};



// WEBPACK FOOTER //
// ./src/utils/StartupUtils.ts